export default[
    {
        path: '/categoria/cadastro',
        name: 'cadastro de categorias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/categoria/lista',
        name: 'lista de categorias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/categoria/editar/:id',
        name: 'editar categorias', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]